<template>
    <div class="horse-preview-other-data flex flex-column mt-2 gap-3">
<!--        <div class="flex gap-3 align-items-center">-->
<!--            <div class="label mt-1">{{ $t('message.horsePreview.otherData.genotypeStatusLabel') }}:</div>-->
<!--            <div v-if="selectedHorse.dnasampleExists" class="value">-->
<!--                <i class="pi pi-check font-bold"/>-->
<!--            </div>-->
<!--            <div v-else class="value">-->
<!--                <i class="pi pi-times font-bold"/>-->
<!--            </div>-->
<!--        </div>-->
        <div class="flex gap-2">
            <span class="label">{{ $t('message.horsePreview.otherData.notesLabel') }}:</span><span class="value notes">{{selectedHorse.notes}}</span>
        </div>
    </div>
</template>

<script>

import CustomTextButton from "@/components/form/CustomTextButton.vue";

export default {
    name: "HorsePreviewOtherData",
    components: {
        CustomTextButton
    },

    props: {
        selectedHorse: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style lang="scss">
@import "../../../../assets/theme/mytheme/variables";
.horse-preview-other-data {
    .label {
        font-size: 18px;
        text-transform: uppercase;
    }

    .value {
        font-family: var(--decor-font-family);
        font-size: 20px;
    }
    .notes {
        white-space: pre-line;
    }
}
</style>
